import React, { useCallback, useMemo } from 'react';

import useAIVoiceSearch from 'js/src/components/app/VoiceSelectionModal/useAIVoiceSearch';
import { SecondaryButton } from 'js/src/components/common/ui/Button';
import type { PlainDropdownItem } from 'js/src/components/common/ui/Dropdown';
import { Dropdown } from 'js/src/components/common/ui/Dropdown';
import type { AIVoiceSortValue } from 'js/src/data/ai-voices-and-avatars/ai-voice-modal/ai-voice-modal-slice';

type SortSelectData = { value: AIVoiceSortValue };

const SORT_OPTIONS: readonly PlainDropdownItem<SortSelectData>[] = [
    { id: 'trending', text: 'Trending', onSelectData: { value: 'trending' } },
    { id: 'a-z', text: 'A to Z', onSelectData: { value: 'a-z' } },
    { id: 'z-a', text: 'Z to A', onSelectData: { value: 'z-a' } },
    { id: 'default', text: 'Default', onSelectData: { value: 'default' } },
];

const MENU_PROPS = { align: 'end' };

const SortToggle = React.memo(function SortToggle({
    text,
    onClick,
    ref,
}: {
    text: string;
    onClick: VoidFunction;
    ref?: React.Ref<HTMLButtonElement>;
}) {
    return <SecondaryButton ref={ref} text={text} iconLeft="list_arrow" onClick={onClick} />;
});

interface AIVoiceSortProps {
    className?: string;
}

const AIVoiceSort: React.FC<AIVoiceSortProps> = ({ className }) => {
    const { selectedSort, onChangeSort } = useAIVoiceSearch();

    const toggleProps = useMemo(
        () => ({
            text: SORT_OPTIONS.find((opt) => opt.id === selectedSort)?.text ?? 'Sort',
        }),
        [selectedSort],
    );

    const handleSelect = useCallback(
        (onSelectData: SortSelectData) => {
            onChangeSort(onSelectData.value);
        },
        [onChangeSort],
    );

    return (
        <div className={className}>
            <Dropdown<SortSelectData>
                ToggleComponent={SortToggle}
                toggleProps={toggleProps}
                items={SORT_OPTIONS}
                onItemSelect={handleSelect}
                menuProps={MENU_PROPS}
            />
        </div>
    );
};

export default AIVoiceSort;
